/* ============================================================
   HYRALUXE search — live results, recent searches, chips.

   Typing queries Shopify's predictive search endpoint, so the results are the
   real catalogue rather than a copy of it. The form still submits normally, so
   the page works with no JS.
   ============================================================ */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const input = $('#search-input');
  if (!input) return;

  const idle = $('#search-idle');
  const live = $('#search-live');
  const countEl = $('#search-count');
  const resultsEl = $('#search-results');
  const clearBtn = $('#search-clear');
  const H = window.HYRA || {};
  const predictive = (H.routes && H.routes.predictiveSearch) || '/search/suggest';

  /* ---------------- Recent searches ---------------- */
  const RECENT_KEY = 'hyraluxe:searches';
  const recentGet = () => {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (err) { return []; }
  };
  const recentPush = q => {
    q = (q || '').trim();
    if (q.length < 2) return;
    const list = recentGet().filter(x => x.toLowerCase() !== q.toLowerCase());
    list.unshift(q);
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
  };

  const head = $('#recent-head');
  const row = $('#recent-row');
  const drawRecent = () => {
    const list = recentGet();
    if (!head || !row) return;
    head.hidden = list.length === 0;
    row.hidden = list.length === 0;
    row.innerHTML = list.map(q =>
      '<button class="chip" type="button" data-fill="' + q.replace(/"/g, '&quot;') + '">' + q + '</button>').join('');
  };
  drawRecent();

  const rc = $('#recent-clear');
  if (rc) rc.addEventListener('click', () => {
    localStorage.removeItem(RECENT_KEY);
    drawRecent();
  });

  /* ---------------- Chips fill the field ---------------- */
  document.addEventListener('click', e => {
    const chip = e.target.closest('[data-fill]');
    if (!chip) return;
    input.value = chip.dataset.fill;
    input.focus();
    run(input.value);
  });

  /* ---------------- Live results ---------------- */
  const esc = s => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  const money = cents => (window.hyraMoney ? window.hyraMoney(cents) : '₹' + Math.round(cents / 100));

  const CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 5 7 7-7 7"/></svg>';

  /* Predictive search returns prices as strings in rupees, not paise. */
  const toCents = v => {
    if (typeof v === 'number') return v;
    const n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  };

  const rowHTML = p => {
    const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
    const now = toCents(p.price);
    const was = toCents(p.compare_at_price);
    let price = '<span class="price-now">' + money(now) + '</span>';
    if (was > now) {
      const off = Math.round((was - now) * 100 / was);
      price += '<span class="price-mrp">' + money(was) + '</span>' +
               '<span class="price-off">' + off + '% OFF</span>';
    }
    return '<a class="prow" href="' + esc(p.url) + '">' +
      '<span class="prow__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="80" loading="lazy">' : '') + '</span>' +
      '<span class="prow__body">' +
        '<span class="prow__title">' + esc(p.title) + '</span>' +
        '<span class="prow__price">' + price + '</span>' +
      '</span>' + CHEV + '</a>';
  };

  let timer;
  let lastQuery = '';

  const run = async term => {
    term = (term || '').trim();
    if (clearBtn) clearBtn.hidden = term.length === 0;

    if (term.length < 2) {
      if (idle) idle.hidden = false;
      if (live) live.hidden = true;
      return;
    }
    if (idle) idle.hidden = true;
    if (live) live.hidden = false;
    if (term === lastQuery) return;
    lastQuery = term;

    try {
      const url = predictive + '.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (countEl) {
        countEl.textContent = products.length +
          (products.length === 1 ? ' RESULT' : ' RESULTS') + ' FOR “' + term + '”';
      }
      if (resultsEl) resultsEl.innerHTML = products.map(rowHTML).join('');

      const empty = $('#search-empty');
      if (products.length === 0) {
        if (!empty && resultsEl) {
          resultsEl.insertAdjacentHTML('afterend',
            '<div class="search-empty" id="search-empty">' +
              '<p class="serif">No sarees match that search.</p>' +
              '<p>Try a colour, a fabric or an occasion — “wine”, “organza”, “wedding”.</p>' +
              '<a class="btn btn--outline btn--sm" href="/collections/all">BROWSE ALL SAREES</a>' +
            '</div>');
        } else if (empty) { empty.hidden = false; }
      } else if (empty) { empty.hidden = true; }
    } catch (err) {
      /* the form still submits; a failed suggestion request is not worth a toast */
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => run(input.value), 220);
  });

  input.closest('form').addEventListener('submit', () => recentPush(input.value));

  if (clearBtn) clearBtn.addEventListener('click', () => {
    input.value = '';
    lastQuery = '';
    run('');
    input.focus();
  });

  if (input.value) recentPush(input.value);
})();
